import { registerTab } from "lib/@components/tabs"
import { registerFeature } from "lib/features"
import { Lazy } from "lib/make-lazy"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { appRoute } from "routes/app/home.runtime"
import { getMaintenanceReferenceDocumentsRequiredDemands } from "./server/constants.mjs"
import { FEATURE_FLAG_MAINTENANCE_REFERENCE_DOCUMENTS } from "./server/feature-flag-maintenance-reference-documents.mjs"

const requiredDemands = getMaintenanceReferenceDocumentsRequiredDemands()

registerFeature({
    numericalId: 5000,
    name: "Maintenance Reference Documents",
    id: FEATURE_FLAG_MAINTENANCE_REFERENCE_DOCUMENTS,
    description: "Internal authoring tool for generating markdown maintenance references from captured screenshots.",
    internalUseOnly: true,
})

registerTab({
    tab: "reviewProjectsTabs",
    id: "referenceDocuments",
    title: "Reference Documents",
    demands: requiredDemands,
    matchAllDemands: true,
    content: (
        <Lazy
            importer={() => import("./routes/maintenance-reference-documents-board")}
            extract="MaintenanceReferenceDocumentsBoard"
            priority={70}
        />
    ),
})

appRoute.register(
    "review-projects/reference-documents/:id",
    <DemandGuard demands={requiredDemands} and>
        <Lazy
            importer={() => import("./routes/maintenance-reference-document-detail")}
            extract="MaintenanceReferenceDocumentDetail"
        />
    </DemandGuard>
)

appRoute.register(
    "authoring-admin/maintenance-reference-documents",
    <DemandGuard demands={requiredDemands} and>
        <Lazy
            importer={() => import("./routes/maintenance-reference-documents-redirect")}
            extract="MaintenanceReferenceDocumentsRedirect"
        />
    </DemandGuard>
)

appRoute.register(
    "authoring-admin/maintenance-reference-documents/:id",
    <DemandGuard demands={requiredDemands} and>
        <Lazy
            importer={() => import("./routes/maintenance-reference-document-redirect")}
            extract="MaintenanceReferenceDocumentRedirect"
        />
    </DemandGuard>
)
